import { useMemo } from 'react'
import useMerchandiseBrandsList from 'hooks/Merchandise/useMerchandiseBrandsList'
import MerchandiseOfferCarousel from './MerchandiseOfferCarousel'
import useMerchandiseBrand from 'hooks/Merchandise/useMerchandiseBrand'
import { getMerchandiseBrandSearchUrl } from '../merchandiseUtils'
import { FormattedMessage } from 'react-intl'

interface Props {
  brandName: string
  trackingPageName: string
}

function MerchandiseBestOfBrandCarousel({ trackingPageName, brandName }: Props) {
  const [brandsList] = useMerchandiseBrandsList({ name: brandName })
  const [brand] = useMerchandiseBrand(brandsList[0])

  const filters = useMemo(() => {
    if (!brand) return
    return {
      brands: [brand?.id],
    }
  }, [brand])

  const titleConfig = useMemo<{ node: React.ReactNode; tracking: string }>(() => {
    if (!brand) {
      return { node: null, tracking: '' }
    }

    switch (brand.name) {
      case 'Apple':
        return {
          node: (
            <FormattedMessage
              id="ELYYpOXeoTFq7dSGgQ_f"
              defaultMessage="Shop the latest from <em>{brandName}</em>"
              description="Title for Apple brand carousel in the merchandise shop section"
              values={{
                brandName: brand.name,
                em: (chunks) => <em>{chunks}</em>,
              }}
            />
          ),
          tracking: `Shop the latest from ${brand.name}`,
        }
      case 'Smeg':
        return {
          node: (
            <FormattedMessage
              id="Z35LopSOR-kf-aUd1iY7"
              defaultMessage="Iconic appliances by <em>{brandName}</em>"
              description="Carousel title for the Smeg brand iconic appliances product showcase section"
              values={{
                brandName: brand.name,
                em: (chunks) => <em>{chunks}</em>,
              }}
            />
          ),
          tracking: `Iconic appliances by ${brand.name}`,
        }
      case 'Samsonite':
        return {
          node: (
            <FormattedMessage
              id="3Ly4H6WPU3ajbjVyUARY"
              defaultMessage="Travel in style with <i>{brandName}</i>"
              description="Heading title for Samsonite brand carousel in the merchandise shop section"
              values={{
                brandName: brand.name,
                i: (chunks) => <i>{chunks}</i>,
              }}
            />
          ),
          tracking: `Travel in style with ${brand.name}`,
        }
      default:
        return {
          node: (
            <FormattedMessage
              id="rXS3fDS-m0dgVnKNVx0t"
              defaultMessage="Discover the best of <em>{brandName}</em>"
              description="Heading title for merchandise brand carousel (default)"
              values={{
                brandName: brand.name,
                em: (chunks) => <em>{chunks}</em>,
              }}
            />
          ),
          tracking: `Discover the best of ${brand.name}`,
        }
    }
  }, [brand])

  if (brand?.name !== brandName) {
    return null
  }

  return (
    <MerchandiseOfferCarousel
      title={titleConfig.node}
      viewAllTo={getMerchandiseBrandSearchUrl(brand)}
      trackingListName={titleConfig.tracking}
      trackingPageName={trackingPageName}
      filters={filters}
    />
  )
}

export default MerchandiseBestOfBrandCarousel
